import React from 'react';
import './MeToo.scss';
import { safeHtml } from '../../../../services/helpers';

export default function MeToo({ content }) {
    return (
        <div className="workshop-me_too" dangerouslySetInnerHTML={safeHtml(content.Texte)} />
    )
}